export const SET_FLAIRS_MODAL =
	'GLOBAL_ADMINISTRATION_FLAIRS/SET_WAITING_TIME_GRIDS';
export const UPATE_FLAIRS =
	'GLOBAL_ADMINISTRATION_FLAIRS/UPATE_FLAIRS';
export const RESET_STATE =
	'GLOBAL_ADMINISTRATION_FLAIRS/RESET_STATE';

export const ADD_BATCH_LIST =
	'GLOBAL_ADMINISTRATION_FLAIRS/ADD_BATCH_LIST';
export const EDIT_BATCH_LIST_ITEM =
	'GLOBAL_ADMINISTRATION_FLAIRS/EDIT_BATCH_LIST_ITEM';
export const REMOVE_BATCH_LIST_ITEM =
	'GLOBAL_ADMINISTRATION_FLAIRS/REMOVE_BATCH_LIST_ITEM';
export const ADD_BATCH_LIST_ITEM_ROW =
	'GLOBAL_ADMINISTRATION_FLAIRS/ADD_BATCH_LIST_ITEM_ROW';
export const UPDATE_BATCH_FORM =
	'GLOBAL_ADMINISTRATION_FLAIRS/UPDATE_BATCH_FORM';

/**
 * @param {object} payload
 */
export function setFlairsModal(payload) {
	return {
		type: SET_FLAIRS_MODAL,
		payload
	};
}
/**
 * @param {object} payload
 */
export function updateFlairs(payload) {
	return {
		type: UPATE_FLAIRS,
		payload
	};
}

/**
 * @param {object} payload
 */
export function resetState() {
	return {
		type: RESET_STATE
	};
}

export function addBatchList(payload) {
	return {
		type: ADD_BATCH_LIST,
		payload
	};
}

export function updateBatchForm(payload) {
	return {
		type: UPDATE_BATCH_FORM,
		payload
	};
}

export function editBatchListItem(payload) {
	return {
		type: EDIT_BATCH_LIST_ITEM,
		payload
	};
}

export function removeBatchListItem(payload) {
	return {
		type: REMOVE_BATCH_LIST_ITEM,
		payload
	};
}

export function addBatchListItemRow() {
	return {
		type: ADD_BATCH_LIST_ITEM_ROW
	};
}
